import { useState } from "react";
import type { ProviderRoleChangeNotification } from "../types";

export const useLivekitRoleChangeNotification =
  (): ProviderRoleChangeNotification => {
    const [hasRoleChangedToModerator, setHasRoleChangedToModerator] =
      useState(false);
    const hideModeratorNotification = () => setHasRoleChangedToModerator(false);
    return {
      roleChangedToModerator: hasRoleChangedToModerator,
      hideModeratorNotification,
    };
  };
